<template>
  <div>
    <p>We could give you a ten page long Terms of Use. Like you'd read that.</p>
    <p>As far as we're concerned, it's simple:</p>
    <ol class="">
      <li>
        Use Freegle to pass on unwanted items direct to others. No sales, no
        swaps, just simple gifts.
      </li>
      <li>Everything must be free and legal.</li>
      <li>Be nice to other freeglers, and they'll be nice to you.</li>
      <li>
        <!-- eslint-disable-next-line-->
        We don't see or check items offered - see our <nuxt-link no-prefetch to="/disclaimer">disclaimer</nuxt-link>.
      </li>
      <li>
        Freegle communities may have additional rules. If you have questions,
        scroll down and use the
        <em>Contact community volunteers</em> button.
      </li>
      <li>
        <!-- eslint-disable-next-line-->
        Please <nuxt-link no-prefetch to="/disclaimer">keep yourself safe and watch out for scams</nuxt-link>.
      </li>
      <li>
        Objectionable content or behaviour will not be tolerated. If you see
        anything inappropriate, suspicious or just dodgy then please
        <nuxt-link no-prefetch to="/help">report it</nuxt-link>.
      </li>
      <li>You must be aged 13 or over, as there is user-generated content.</li>
      <li>
        <!-- eslint-disable-next-line-->
        We'll keep your personal data private - see <nuxt-link no-prefetch to="/privacy">privacy page</nuxt-link>.
      </li>
      <li>
        <!-- eslint-disable-next-line-->
        Your posts will be public - see <nuxt-link no-prefetch to="/privacy">privacy page</nuxt-link>.
      </li>
      <li>
        <!-- eslint-disable-next-line-->
        We will email you posts, replies, events, newsletters, etc. - control these in <nuxt-link  no-prefetch to="/settings">Settings</nuxt-link>.
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
